import { managedEntities } from '~/services/serviceInstances';

import { DataWrapper } from '../../ApiTypes';
import { Group } from './types';

export const deleteGroup = async (groupId: string) => {
  const response = await managedEntities.remove<DataWrapper<Group>>(
    `/groups/${groupId}`,
  );
  return response.data;
};
